export default {
  //
  //  Local name of the language
  //
  languageLocalName: 'Deutsch',

  //
  // General
  //
  changeLanguage: 'Sprache wechseln',
  supportMe: 'Unterstütze BadTranslator',
  shareButtonTitle: 'Teile diese Seite',
  subtitle: 'Ein Spiel wie <em>Stille Post</em> aber mit Online Übersetzern. <br />Übersetze deine Nachricht durch zufällige Sprachen und wieder zurück.',
  selectLanguage: 'Sprache des Eingabetexts',
  translationRoundsHelp: 'Wähle wie viele Runden übersetzt werden sollen.',
  translationRounds: 'Übersetze {n}-mal',
  useExample: 'Benutze ein Beispiel (Englisch)',
  textInputPlaceholder: 'Gib hier den Text ein, den du übersetzen willst',
  translateButton: 'Übersetzen!',
  shareTranslation: 'Teile diese Übersetzung',
  shareTranslationTitle: 'Das kommt dabei raus, wenn man einen Text durch zufällige Sprachen übersetzt',
  tryAgain: 'Versuche es nochmal mit anderen Sprachen!',
  tryAgainDescription: 'Das Ergebnis ist zu verrückt? 👉 Versuche es nochmal mit weniger Übersetzungsrunden.<br />Nicht verrückt genug? 👉 Erhöhe die Zahl der Runden.<br />Tipp: 💡 Gib einen englischen Text ein aber wähle deutsch als Ausgangssprache (funktioniert auch mit den Templates).',
  howItWorksTitle: 'Wie funktioniert das?',
  howItWorksParagraph1: 'Diese Seite orientiert sich am Spiel <em>Stille Post</em>, nur halt mit Online Übersetzern statt mit echten Menschen.\
      Dein Text wird durch verschiedene zufällig ausgewählte Sprachen und dann zurück in die Ausgangssprache übersetzt.',
  supportModalTitle: 'Hallo',
  supportModalText: "Entschuldigung für die Unterbrechung aber ich habe gesehen, dass du BadTranslator schon {translationCount}-mal benutzt hast. Ich hoffe dir gefällt diese App und sie konnte dich zum Lachen bringen 😊\
    <br/>Diese Seite wird immer kostenlos bleiben, die Übersetzerdienste, die ich im Hintergrund verwende, kosten mich jedoch Geld.\
    <br/>\
    <br/>Wenn dir diese App gefällt würde ich mich sehr über eine Spende freuen, damit ich sie auch weiterhin betreiben kann.",
  supportModalThanks: "Wenn du nicht spenden kannst ist das gar kein Problem. Wenn du trotzdem helfen möchtest, dann teile diese Seite mit deinen Freunden.\
      <br />Vielen Dank für deine Unterstützung und weiterhin viel Spaß!",
  donateOnX: "Spende auf {x}",
  alreadyDonated: "Ich habe schon gespendet",
  thinkingAboutDonating: "Ich denke drüber nach",
  wontDonate: 'Hau ab',

  shareTitle: 'Spiele Übersetzer-"Stille Post" auf BadTranslator',
  shareText: 'Auf BadTranslator.net kannst du "Stille Post" mit Online-Übersetzern spielen. Übersetze deinen Text durch zufällige Sprachen und schaue was dabei rauskommt.',
  donateTextColumn: 'Die Bereitstellung von BadTranslator ist nicht billig. Wenn du Spaß an BadTranslator hast, würde ich mich über eine kleine Spende freuen um die laufenden Kosten zu bezahlen.<br/>Danke.',
};
